import resources from '../resource.js';

const baseDomain = process.env.VUE_APP_ENDPOINT;
const baseUrl = `${baseDomain}/api/`;
const resource = 'blog';

export default {
    index() {
        return resources.get(`${resource}`);
    },
    show(id) {
        return resources.get(`${resource}/${id}`);
    },
    store() {
        return `${baseUrl}${resource}`
    },
    update(id, payload) {
        return resources.put(`${resource}/${id}`, payload);
    },
    destroy(id) {
        return resources.delete(`${resource}/${id}`);
    },
}
